module.exports = __webpack_public_path__ + "img/hbg.5c7abaec.png";